import { useState, useCallback, useEffect } from 'react';
import { Container, Flex, Heading, Box } from '@chakra-ui/react';
import { Sling as Hamburger } from 'hamburger-react';

// Components
import CustomDrawer from '../drawer/drawer';
import NetworkSelection from '../networkSelection/networkSelection';
import { useLocation } from 'react-router-dom';

type HeaderProps = {};

const Header = (props: HeaderProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const location = useLocation();

    const handleClose = useCallback(() => setIsOpen(!isOpen), [isOpen]);

    return (
        <Box bg='blue.500' p={4}>
            <Container maxW='6xl'>
                <Flex direction='row' color='white'>
                    <Flex direction='row' flex='1' alignItems='center'>
                        <Box>
                            <Hamburger toggled={isOpen} toggle={setIsOpen} />
                        </Box>
                    </Flex>
                    <Flex flex='1' alignItems='center' justifyContent='center'>
                        <a href='https://bis-hub.com' target='_blank'>
                            <Heading variant='white' size='lg'>
                                BIS HUB
                            </Heading>
                        </a>
                    </Flex>
                    <Flex flex='1' justifyContent='flex-end'>
                        {location.pathname !== '/wallet/create' && (
                            <NetworkSelection />
                        )}
                    </Flex>
                </Flex>
            </Container>
            <CustomDrawer onClose={handleClose} isOpen={isOpen} />
        </Box>
    );
};

export default Header;
